/** @format */

import React, { useContext, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { useTranslation } from "react-i18next";
import Tooltip from "../../Components/Common/Tooltip";
import { roles } from "../../Config/Roles";
import { AuthContext } from "../../Contexts/AuthContext";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { posVersionService } from "../../Services/posVersion.services";
import ActionModal from "../Common/ActionModal";
import ResultModal from "../Common/ResultModal";
import SpinnerLoading from "../Common/SpinnerLoading";
import AddPosVersion from "./AddPosVersion";
import UpdatePosVersion from "./UpdatePosVersion";

import { globalServices, posServices } from "../../Services";
import { useHistory } from "react-router-dom";
import Button from "../Common/AIChatModal/Button/Button";
import "./ManagingVersions.css";
import ImportFileModal from "./ImportFileModal";
import AddVersionToClient from "./AddVersionToClient";
import AddVersionToAllPos from "./AddVersionToAllPos";

const ManagingVersions = () => {
  const history = useHistory();

  const { t: translator } = useTranslation();
  const { updateLocName } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;
  const [selectedVersion, setSelectedVersion] = useState(0);

  const isActionAllowed = [master, admin, support].includes(parseInt(roleId));

  const { SearchBar } = Search;

  const [isLoading, setIsLoading] = useState(true);
  const [posVersions, setPosVersion] = useState([]);
  const [updateData, setUpdateData] = useState(null);
  const [update, setUpdate] = useState(new Date());
  const initialSelectedItems =
    JSON.parse(localStorage.getItem("selectedPosItems")) || [];
  const initialSelectedIctItems =
    JSON.parse(localStorage.getItem("selectedPosIctItems")) || [];

  const [posList, setPosList] = useState([]);
  const [selectedItems, setSelectedItems] = useState(initialSelectedItems);
  const [selectedIctItems, setSelectedIctItems] = useState(
    initialSelectedIctItems
  );
  const [showFileModal, setShowFileModal] = useState(false);
  const [showAddToClient, setShowAddToClient] = useState(false);
  const [showAddToAllPos, setShowAddToAllPos] = useState(false);
  const [stores, setStores] = React.useState();
  const [document, setDocument] = useState(null);
  const [filters, setFilters] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : null,
    storeId: 0,
    searchText: "",
    isDeactivated: false,
    sortName: "ActivationDate",
    isAsc: false,
  });
  const [resultModal, setResultModal] = useState({
    show: false,
    title: "",
    text: "",
    btnClass: "",
  });

  const [actionModal, setActionModal] = useState({
    show: false,
    title: "",
    text: "",
    confirmBtn: "",
  });
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const handleTableChange = (type, { page, sizePerPage }) => {
    setIsLoading(true);
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const handleOnSelect = (row, isSelect) => {
    let newSelectedItems;
    let newSelectedIctItems;
    if (isSelect) {
      newSelectedItems = [...selectedItems, row.posid];
      newSelectedIctItems = [...selectedIctItems, row.inventoryNumber];
    } else {
      newSelectedItems = selectedItems.filter((p) => p !== row.posid);
      newSelectedIctItems = selectedIctItems.filter(
        (p) => p !== row.inventoryNumber
      );
    }
    setSelectedItems(newSelectedItems);
    setSelectedIctItems(newSelectedIctItems);
    localStorage.setItem("selectedPosItems", JSON.stringify(newSelectedItems));
    localStorage.setItem(
      "selectedPosIctItems",
      JSON.stringify(newSelectedIctItems)
    );
  };

  const handleOnSelectAll = (isSelect) => {
    let newSelectedItems;
    let newSelectedIctItems;
    if (isSelect) {
      newSelectedItems = posList.map((x) => x.posid);
      newSelectedIctItems = posList.map((x) => x.inventoryNumber);
    } else {
      newSelectedItems = [];
      newSelectedIctItems = [];
    }

    setSelectedItems(newSelectedItems);
    setSelectedIctItems(newSelectedIctItems);

    localStorage.setItem("selectedPosItems", JSON.stringify(newSelectedItems));
    localStorage.setItem(
      "selectedPosIctItems",
      JSON.stringify(newSelectedIctItems)
    );
  };
  useEffect(() => updateLocName("managing-version"), []);
  useEffect(() => {
    setIsLoading(true);
    posVersionService
      .getAll()
      .then((res) => {
        console.log("xx", res.data);
        setPosVersion(res.data);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [update]);

  useEffect(() => {
    posServices
      .getSearch({
        tenantId: Number(filters.tenantId),
        storeId: Number(filters.storeId),
        searchText: filters.searchText,
        isDeactivated: filters.isDeactivated,
        sortName: filters.sortName,
        isAsc: filters.isAsc,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setPosList(res.data.posDevices);

        setPagination({ ...pagination, totalCount: res.data.totalCount });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  }, [update, filters]);

  const handleInputChange = (event) => {
    setIsLoading(true);
    setFilters({ ...filters, searchText: event.target.value });
    setPagination({ ...pagination, pageIndex: 0 });
  };
  function checkFormatter(cell) {
    return cell ? "Da" : "";
  }
  function rowStyleSuspended(row, rowIdx) {
    return {
      backgroundColor: row.isSuspended ? "#fcaeae" : "inherit",
    };
  }

  // function actionFormatter(rowId, row) {
  //   return row.isCurrent ? (
  //     <div></div>
  //   ) : (
  //     <div
  //       className="action"
  //       onClick={(e) => {
  //         e.stopPropagation();
  //         onClickDelete(rowId);
  //       }}
  //     >
  //       <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
  //     </div>
  //   );
  // }
  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={selectedItems.find((x) => x === row.posid)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }
  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={
              posList &&
              posList.length > 0 &&
              !posList
                .map((p) => p.posid)
                .some((p) => selectedItems.indexOf(p) < 0)
            }
            onChange={(e) => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }
  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div className="tableCont">
      <BootstrapTable
        remote
        keyField="posid"
        data={data}
        columns={columns}
        //rowEvents={rowEvents}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        rowStyle={rowStyleSuspended}
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );
  const columns = [
    {
      dataField: "posId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,

      formatter: actionFormatter,
      hidden: !isActionAllowed,
      // hidden: [cashier, accountant].includes(Number(roleId)) ? true : false,
    },
    // {
    //   dataField: "name",
    //   text: translator("Administration-PosVersion-Name"),
    // },
    // {
    //   dataField: "isCurrent",
    //   text: translator("Administration-PosVersion-IsCurrent"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "100px", textAlign: "center" };
    //   },
    //   formatter: checkFormatter,
    // },
    {
      dataField: "inventoryNumber",
      text: translator("POS-List-TableHeader-Ict"),

      sort: true,
    },
    {
      dataField: "posserialNumber",
      text: translator("POS-List-TableHeader-SerialNumber"),

      sort: true,
    },
  ];
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (updateData == row) {
        setUpdateData(null);
      } else {
        setUpdateData(row);
      }
    },
  };

  const addVersion = () => {
    posVersionService
      .posAddToSelectedVersion(selectedVersion, selectedItems)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        setResultModal({
          ...resultModal,
          title: translator("PosVersion-ResultModal-AddVersionSuccess-Title"),
          text: translator("PosVersion-ResultModal-AddVersionSuccess-Text"),
          show: true,
          btnClass: "btn btn-primary",
        });
        setUpdate(new Date());
        setSelectedItems([]);
        setSelectedIctItems([]);
        localStorage.setItem("selectedPosItems", JSON.stringify([]));
        localStorage.setItem("selectedPosIctItems", JSON.stringify([]));
      })
      .catch((err) =>
        setResultModal({
          ...resultModal,
          title: translator("PosVersion-ResultModal-AddVersionError-Title"),
          text: translator("PosVersion-ResultModal-AddVersionError-Text"),
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  const clearSelected = () => {
    setSelectedVersion(0);

    setSelectedItems([]);
    setSelectedIctItems([]);
    localStorage.setItem("selectedPosItems", JSON.stringify([]));
    localStorage.setItem("selectedPosIctItems", JSON.stringify([]));
    return;
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap titleContainer">
          <span>{translator("PosVersion-Managing-Subtitle")}</span>

          <div className="addVersionsContainer">
            <button
              className="btn btn-outline-secondary"
              onClick={() => setShowAddToClient(true)}
            >
              {translator("ManagingVersion-AddVersion-Tenant")}
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => setShowAddToAllPos(true)}
            >
              {translator("ManagingVersion-AddVersion-All")}
            </button>
          </div>
        </div>
        <div className="containerHeader">
          <div>
            <label>{translator("POS-List-labelTag")}</label>{" "}
            <Tooltip
              text={translator(
                "Pretraživanje je moguće po ICT broju i serijskom broju"
              )}
            />
            <input
              name="searchText"
              type="text"
              className="form-control"
              defaultValue={filters.searchText}
              onChange={handleInputChange}
            />
          </div>

          <button
            appearance="primary"
            onClick={() => setShowFileModal(true)}
            className="btn btn-primary"
          >
            {translator("ManagingVersion-ImportFile")}
          </button>
        </div>
        <div className="card-body ">
          <div className="row mb-2">
            <div className="col-md-12 col-sm-12 mt-0">
              <div
                style={{ margin: 5, marginBottom: "20px" }}
                className="alert alert-warning"
                role="alert"
              >
                {selectedIctItems.map((x) => x).join(", ") ||
                  translator("PosVersion-SelectPos-Msg")}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-7 col-sm-12 mt-2">
              {isLoading ? (
                <div className="dashboard-card-spinner">
                  <SpinnerLoading />
                </div>
              ) : (
                <RemoteAll
                  data={posList}
                  page={pagination.pageIndex + 1}
                  sizePerPage={pagination.pageSize}
                  noDataIndication={translator("No-Data")}
                  totalSize={pagination.totalCount}
                  onTableChange={handleTableChange}
                />
              )}
            </div>

            <div className="col-md-5 col-sm-12 mt-2">
              <select
                className="form-control"
                name="posVersionId"
                onChange={(e) => {
                  console.log(e.target.value);
                  setSelectedVersion(e.target.value);
                }}
              >
                <option value="0">{translator("Select-Version")}</option>
                {posVersions &&
                  posVersions.map((x) => (
                    <option value={x.posVersionId}>{x.name}</option>
                  ))}
              </select>
              <hr></hr>

              <div>
                <button
                  onClick={() => clearSelected()}
                  className="btn btn-outline-secondary mr-3 "
                >
                  {translator("ManagingVersion-ClearSelection")}
                </button>
                {""}
                <button
                  appearance="primary"
                  onClick={addVersion}
                  disabled={
                    !selectedVersion || selectedItems.length == 0 ? true : false
                  }
                  className="btn btn-primary"
                >
                  {translator("ManagingVersion-AddVersion")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={() => {
          setResultModal({ ...resultModal, show: false });
          setUpdateData(null);
        }}
      />

      <ActionModal
        show={actionModal.show}
        handleHide={() => {
          setActionModal({ ...actionModal, show: false });
        }}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />

      <ImportFileModal
        showFileModal={showFileModal}
        setShowFileModal={setShowFileModal}
        setDocument={setDocument}
      />
      <AddVersionToClient
        setShowAddToClient={setShowAddToClient}
        showAddToClient={showAddToClient}
      />
      <AddVersionToAllPos
        setShowAddToAllPos={setShowAddToAllPos}
        showAddToAllPos={showAddToAllPos}
      />
    </div>
  );
};

export default ManagingVersions;
